<startup-loading></startup-loading>
<startup-error></startup-error>
@if(appIntroService.visible()){
<app-intro></app-intro>
}

<router-outlet></router-outlet>
